import React from 'react';
import cx from 'classnames';

import Loading from '../../Testimonials/Components/Respondents/Loading';
import Image, { ImageProps, ImageType } from './Image';

export interface ImageContainerProps extends ImageProps {
  loading?: boolean;
}

export default function ImageContainer({
  imageType,
  loading,
  imageUrl,
}: ImageContainerProps) {
  return (
    <div
      className={cx('flex justify-center items-center h-[70px]', {
        'border-none w-[70px] overflow-hidden flex items-center justify-center rounded-full':
          imageType === ImageType.Circle,
        'border border-solid border-neutral w-[132px] px-1':
          imageType === ImageType.Square,
      })}
    >
      {loading ? (
        <Loading
          className={cx('flex items-center flex-col', {
            'rounded-full w-16': imageType === ImageType.Circle,
            'w-[132px]': imageType === ImageType.Square,
          })}
        />
      ) : (
        <Image imageType={imageType} imageUrl={imageUrl} />
      )}
    </div>
  );
}
